import { render, staticRenderFns } from "./NavFirstIcon.vue?vue&type=template&id=6851db0b"
import script from "./NavFirstIcon.vue?vue&type=script&lang=js"
export * from "./NavFirstIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports